import React from 'react'
import InputFieldUI from './InputFieldUI'
import './InputSelect.css'

const InputSelectUI = ({ context, name, value, optionList,
  label, messageList, labelKey, help,
  onChange, required, disabled, error }) =>
  <InputFieldUI className='w_input_sel' name={name} required={required} label={label}
    messageList={messageList} labelKey={labelKey} help={help}>
    <select name={name} value={value} onChange={onChange}
      disabled={disabled} className={`select ${error ? 'hasError' : ''}`}>
      {
        !value &&
        <option></option>
      }
      {
        optionList && optionList.map((option, i) =>
          <option className='select_option' key={i} value={option.key}>{option.value}</option>
        )
      }
    </select>
  </InputFieldUI>

export default InputSelectUI
